"use client";

/**
 * Scrolling band of the flags our users sign from.
 *
 * Uses bundled PNGs from /public/flags rather than emoji: Windows ships no
 * country-flag emoji font, so 🇺🇸 degrades to the bare letters "US" for a large
 * share of desktop visitors. The PNGs are 64x48 and ~1KB each.
 */
export default function FlagBand({
  codes,
  max = 44,
  className = "",
}: {
  codes: string[];
  max?: number;
  className?: string;
}) {
  const shown = codes.slice(0, max);
  if (shown.length === 0) return null;

  return (
    <div
      className={`overflow-hidden ${className}`}
      style={{
        maskImage: "linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent)",
        WebkitMaskImage: "linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent)",
      }}
    >
      {/* duplicated once so the -50% translate loops seamlessly */}
      <div className="sf-flag-track flex w-max items-center gap-4">
        {[...shown, ...shown].map((cc, i) => (
          <img
            key={`${cc}-${i}`}
            src={`/flags/${cc.toLowerCase()}.png`}
            alt={i < shown.length ? cc : ""}
            aria-hidden={i >= shown.length}
            width={32}
            height={24}
            /* eager, not lazy: the band scrolls continuously, so a lazily-loaded
               flag pops in mid-travel. Only ~44 unique files at ~1KB each — the
               duplicate half re-uses the same URLs from cache. */
            loading="eager"
            decoding="async"
            className="h-[22px] w-auto shrink-0 rounded-[2px] shadow-sm shadow-black/30"
          />
        ))}
      </div>
    </div>
  );
}
